import { getReseller } from '@/api/reseller';
import { useAppDispatch } from '@/store/hooks/useAppDispatch';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getResellerAuthenticationStatus } from '@/store/reseller/selector';
import { setResellerAccountInfo } from '@/store/reseller/slice';
import { Reseller } from '@/types/TReseller';
import LocalStorageUtility from '@/utils/localStorage';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { LocalStorageKeys } from 'src/enums/ELocalStorage';
import { USER_TYPES } from 'src/enums/EUser';

const useResellerAuth = () => {
	const isAuthenticated = useAppSelector(getResellerAuthenticationStatus);

	const dispatch = useAppDispatch();
	const authenticationStatus =
		LocalStorageUtility.getLocalData(LocalStorageKeys.RESELLER_AUTH_TOKEN) ?? isAuthenticated;

	const { data, isLoading, error, refetch } = useQuery({
		queryKey: ['reseller'],
		queryFn: () => getReseller({ from: USER_TYPES.RESELLER }),
		enabled: Boolean(
			!!authenticationStatus &&
				!!LocalStorageUtility.getLocalData(LocalStorageKeys.RESELLER_AUTH_TOKEN),
		),
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		retry: false,
	});

	useEffect(() => {
		const authToken = new URLSearchParams(window.location.search).get('RESELLER_AUTH_TOKEN');
		if (authToken) {
			LocalStorageUtility.setLocalData(LocalStorageKeys.RESELLER_AUTH_TOKEN, authToken);
			// origin + /reseller_portal
			// window.location.href = window.location.origin;

			window.location.href = `${window.location.origin}/reseller_portal`;
		}
		if (data) {
			dispatch(
				setResellerAccountInfo({
					data: data.data as Reseller,
					authToken: data.token,
					isAuthenticated: !!data.token,
					clients: [],
				}),
			);
		} else if (error) {
			LocalStorageUtility.removeLocalData(LocalStorageKeys.RESELLER_AUTH_TOKEN);
			window.location.href = '/reseller_portal';
		}
	}, [data, error]);

	return {
		isAuthenticated: authenticationStatus,
		isLoading,
		refetch,
	};
};

export default useResellerAuth;
